import(/* webpackMode: "eager" */ "/vercel/path0/app/layout.js");
